import { render, staticRenderFns } from "./RateForm.vue?vue&type=template&id=592fef6a&scoped=true&"
import script from "./RateForm.vue?vue&type=script&lang=js&"
export * from "./RateForm.vue?vue&type=script&lang=js&"
import style0 from "./RateForm.vue?vue&type=style&index=0&id=592fef6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592fef6a",
  null
  
)

export default component.exports